export default __webpack_public_path__ + "static/media/l.f136cd43.mp4";